import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Fullmakter = lazy(() => import("@/pages/mina-sidor/Fullmakter"));

export const Route = createFileRoute("/mina-sidor/fullmakter")({
  component: () => <Fullmakter />,
});
